export function parseContentDispositionFilename(header?: string): string | null {
  if (!header) return null;

  const utf8Match = header.match(/filename\*=UTF-8''([^;\n]+)/i);
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1].replace(/"/g, ''));
  }

  const quotedMatch = header.match(/filename="([^"]+)"/i);
  if (quotedMatch) {
    return quotedMatch[1];
  }

  const plainMatch = header.match(/filename=([^;\n]+)/i);
  return plainMatch ? plainMatch[1].trim().replace(/"/g, '') : null;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export async function parseBlobError(error: unknown): Promise<string> {
  const response = (error as { response?: { data?: unknown; status?: number } })?.response;
  if (!(response?.data instanceof Blob)) {
    const detail = (response?.data as { detail?: string; message?: string } | undefined)?.detail
      ?? (response?.data as { detail?: string; message?: string } | undefined)?.message;
    return detail || (error as Error)?.message || 'Download failed';
  }

  const text = await response.data.text();
  try {
    const json = JSON.parse(text) as { detail?: string; message?: string };
    return json.detail || json.message || text || 'Download failed';
  } catch {
    return text || 'Download failed';
  }
}
